import { createResolvable } from "utils"

export type Config = {
  project: string
}

export const { promise: config, resolve: initializeLocalise } =
  createResolvable<Config>()
